import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { IS_NOT_EMPTY } from 'cargo-chief-commons';

/**
 * Prompts for the exclusion scope (global vs. keep-on-workflows) and a required reason.
 * Returns { keepInWorkflows, reason } on confirm, or null on cancel.
 */
@Component({
	selector: 'app-exclude-carrier-dialog',
	templateUrl: './exclude-carrier-dialog.component.html',
})
export class ExcludeCarrierDialogComponent implements OnInit {
	IS_NOT_EMPTY = IS_NOT_EMPTY;

	// false = global exclusion (remove from all workflows); true = limited (keep on current workflows)
	keepInWorkflows = false;
	reasonControl: UntypedFormControl;

	constructor(
		public dialogRef: MatDialogRef<ExcludeCarrierDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		public utilService: UtilService
	) {}

	ngOnInit() {
		this.reasonControl = new UntypedFormControl('', [Validators.required]);
	}

	confirm(): void {
		const reason = (this.reasonControl.value || '').trim();
		if (!IS_NOT_EMPTY(reason)) {
			this.reasonControl.markAsTouched();
			this.utilService.showSnackbar('A reason is required.', SNACKBAR.ERROR, SNACKBAR.ACTION);
			return;
		}
		this.dialogRef.close({ keepInWorkflows: this.keepInWorkflows, reason });
	}

	closeDialog(): void {
		this.dialogRef.close(null);
	}
}
